/**
 * aggiunge una quantità a un carrello
 */
function addToCart(product) {
    var quantity = $('#input-qty').val();

    var alternative = false;
    if($('#alternative-selection').length > 0) {
        alternative = $('#alternative-selection').val();

        if(alternative == '0') {
            return false;
        }
    }

    $.get( url_cart_addToCart, {
        product: product,
        productAlternative: alternative,
        quantity: quantity
    } , function( data ) {

        try {
            data = JSON.parse(data);
        } catch (e) {
            location.reload();
        }

        if(!data.error) {
            $('.js-addToCart-title').html(data.result.product.name);
            $('.js-addToCart-image').attr('src', data.result.product.imageFilename);
            $('.js-addToCart-quantity').html(data.result.quantity);
            $('.js-addToCart-total').html(data.result.cart.total_format + ' €');
            $('.js-addToCart-counter').html(data.result.cart.counter);

            $(".js-cart-counter").text(data.result.cart.counter).show();

            $('[data-js="modal-cart"]').modal('show');

            tagManager_AddToCart({
                'name': data.result.product.name,
                'id': data.result.product.code,
                'price': data.result.product.price,
                'brand': data.result.product.brand,
                'category': data.result.product.productLine,
                'quantity': data.result.quantity,
                'variant': data.result.product.variant
            });

        } else if (data.error_status == 'NOTENOUGH') {
            var li = '<li><strong>'+data.product.name+' - '+text__ecommerce__quantity+': '+data.totAvailability+'</strong></li>';
            $('[data-js="modal-cart-checkQuantity"]').find('ul').html('');
            $('[data-js="modal-cart-checkQuantity"]').find('ul').append(li);
            $('[data-js="modal-cart-checkQuantity"]').modal('show');
        }
    });
}

/**
 * aggiorna la quantità di un prodotto presente nel carrello
 */
function updateCartRow(product, productAlternative, cartRow, fidelityActive, refresh) {
    $('.js-reload').removeClass('D(n)');
    $('.js-submit').addClass('D(n)');

    var qtyInput = $('.input-update-qty[data-cart-row="'+cartRow+'"]');
    var priceLabel = $('.cart-price-label[data-cart-row="'+cartRow+'"]');
    var priceOriginalLabel = $('.cart-original-price-label[data-cart-row="'+cartRow+'"]');
    var vatLabel = $('.cart-vat-label[data-cart-row="'+cartRow+'"]');
    var updateButton = $('.btn-update-qty[data-cart-row="'+cartRow+'"]');
    var quantity = qtyInput.val();

    $.get( url_cart_addToCart, {
        product: product,
        productAlternative: productAlternative,
        quantity: quantity,
        overwriteQuantity: 1
    } , function( data ) {

        try {
            data = JSON.parse(data);
        } catch (e) {
            location.reload();
        }

        if(!data.error) {
            // if(fidelityActive == '1') {
            //     location.reload();
            // }
            // if(refresh == '1') {
            //     location.reload();
            // }

            // countItemsInCart();
            //
            // priceLabel.html(data.result['price_total_format'] + ' €').show();
            // if (priceOriginalLabel) {
            //     priceOriginalLabel.html(data.result['original_price_total_format'] + ' €').show();
            // }
            // vatLabel.html(data.result['vat_total_format'] + ' €').show();
            // updateButton.hide();
            // qtyInput.attr('data-val', quantity);
            //
            // $('#cart-total-coupon').html(data.result.cart['total_no_coupon_format'] + ' €');
            // $('#cart-discount').html(data.result.cart['discount_format'] + ' €');
            // $('#cart-total').html(data.result.cart['total_format'] + ' €');


        } else if (data.error_status == 'NOTENOUGH') {

        }
    });
}

/**
 * rimuove un articolo dal carrello
 */
function removeFromCart(cartRow, fidelityActive) {
    $('.js-reload').removeClass('D(n)');
    $('.js-submit').addClass('D(n)');

    $.get( url_cart_removeFromCart, {
        cartRow: cartRow,
    } , function( data ) {

        try {
            data = JSON.parse(data);
        } catch (e) {
            location.reload();
        }

        if(!data.error) {
            tagManager_AddToCart({
                'name': data.result.product.name,
                'id': data.result.product.code,
                'price': data.result.product.price,
                'brand': data.result.product.brand,
                'category': data.result.product.productLine,
                'quantity': data.result.product.quantity,
                'variant': data.result.product.variant
            });

            if(fidelityActive == '1') {
                location.reload();
            }

            countItemsInCart();

            $('tr[data-cart-row="'+cartRow+'"]').remove();

            $('#cart-total-coupon').html(data.result.cart['total_no_coupon_format'] + ' €');
            $('#cart-discount').html(data.result.cart['discount_format'] + ' €');
            $('#cart-total').html(data.result.cart['total_format'] + ' €');
        }
    });
}

/**
 * controlla se il codice coupon esiste, e in caso, applica il coupon al carrello
 */
function applyCoupon() {
    var code = $('#coupon-code').val();

    $.get( url_cart_applyCoupon, {
        couponCode: code
    } , function( data ) {

        try {
            data = JSON.parse(data);
        } catch (e) {
            // @TODO RIATTIVA 
            location.reload();
        }

        if(data.validCoupon) {
            location.reload();
            // $('#applied-coupon-cnt').html('<span>' + data.code + '</span><a href="javascript:void(0);" onclick="removeCoupon();">rimuovi</a>');
            // $('#applied-coupon').show();
            // $('#apply-coupon').hide();
            // $('#coupon-code').val('');
        } else {
            $('#appCoupon-message').html(data.messageTxt);
            $('[data-js="modal-cart-addCoupon"]').modal('show');
            $('input#coupon-code').val('');
        }
    });
}

/**
 * rimuove il coupon applicato al carrello
 */
function removeCoupon() {
    $.get( url_cart_removeCoupon, {} , function( data ) {

        try {
            data = JSON.parse(data);
        } catch (e) {
            location.reload();
        }

        if(data.success) {
            location.reload();
            // $('#applied-coupon-cnt').html('');
            // $('#applied-coupon').hide();
            // $('#apply-coupon').show();
        }
    });
}

$('.input-update-qty').on('keyup change', function() {
    var cartRow = $(this).attr('data-cart-row');
    var product = $(this).attr('data-product');
    var productAlternative = $(this).attr('data-product-alternative');
    var fidelity = $(this).attr('data-fidelity');
    var refresh = $(this).attr('data-refresh');

    updateCartRow(product, productAlternative, cartRow, fidelity, refresh);
});

$('#alternative-selection').on('change', function() {
    var price = $('#alternative-selection option').filter(':selected').attr('data-price');
    var price_js = parseFloat($('#alternative-selection option').filter(':selected').attr('data-price-js'));
    var priceNoDiscount = $('#alternative-selection option').filter(':selected').attr('data-price-no-discount');
    var priceNoDiscount_js = parseFloat($('#alternative-selection option').filter(':selected').attr('data-price-no-discount-js'));
    var addToCartButton = $('#add_to_cart_button');
    var quantity = $('#alternative-selection option').filter(':selected').attr('data-quantity');
    var vat = $('#alternative-selection option').filter(':selected').attr('data-vat');

    if (priceNoDiscount_js > price_js) {
        $('.js-alternative-price-no-discount').html(priceNoDiscount);
        $('.spaceVat').show();
    } else {
        $('.js-alternative-price-no-discount').html('');
        $('.spaceVat').hide();
    }

    $('.js-alternative-price').html(price);
    $('.js-alternative-vat').html(vat);

    if(parseInt(quantity) <= 0) {
        addToCartButton.attr('disabled', 'disabled');
        $('.buttonAvailable').hide();
        $('.buttonNotAvailable').show();
    }
    else {
        addToCartButton.removeAttr('disabled');
        $('.buttonAvailable').show();
        $('.buttonNotAvailable').hide();
    }
});

$(document).on('submit', '#checkout_form', function (e) {
    $('#checkout_submit_button').hide();
    $('#checkout_submit_loader').show();
});